import { Component, OnInit } from '@angular/core';
import { QrCodeService } from 'app/modules/shared/services/qr-code.service';

@Component({
  selector: 'app-qr-code-for-app',
  templateUrl: './qr-code-for-app.component.html',
  styleUrls: ['./qr-code-for-app.component.scss']
})
export class QrCodeForAppComponent implements OnInit {
  qrImageShortLinkPassenger: string = ''; 
  qrImageShortLinkDriver: string = ''; 

  version: string = '1.2'; 
  deviceType: string = 'android'; 
  qrImageForDriver: any;
  qrImageForPassenger: any;

  constructor(private qrCodeService: QrCodeService) {}
  
  ngOnInit() {
    this.passengerQrCode();
    this.driverQrCode();
  }

  passengerQrCode(){
    this.qrCodeService.getPassengerQr('passenger').subscribe(
      (response) => {
        this.qrImageForPassenger = response.versionDetails.qrImage;
        this.qrImageShortLinkPassenger = response.versionDetails.qrImageShortLink;
      },
      (error) => {
        console.error('Error fetching version details:', error);
      }
    );
  }

  driverQrCode(){
    this.qrCodeService.getDriverQr('driver').subscribe(
      (response) => {
        this.qrImageForDriver = response.versionDetails.qrImage;
        this.qrImageShortLinkDriver = response.versionDetails.qrImageShortLink;
      },
      (error) => {
        console.error('Error fetching version details:', error);
      }
    );
  }

}
